<button type="button" class="visibility-button" (click)="toggleVisibility()">
  @if (isVisible) {
    <img src="assets/svg/icon-visibility-on.svg" alt="Hide Content" />
  } @else {
    <img src="assets/svg/icon-visibility-off.svg" alt="Show Content" />
  }
</button>
